import { ToneDetailsPopupCSSStyle } from './tonedetailspopupcss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { ToneDetailsPopupComponentHandler, ToneDetailsPopupComponentProps } from './tonedetailspopupcomponent';
import { ImageLoaderComponent } from '../../../toolkit/imageloader/imageloadercomponent';
import { ToneDetailsPopupImageLoaderCSSStyleImpl } from './tonedetailsimageloadercss';
import './tonedetailspopup-style.css';

export class ToneDetailsPopupViewImpl extends UIComponentViewImpl<UIDataModel>
{
    // private playerComponent: PlayerComponent | null;
    // private initialStateOfTonePlaying: boolean;

    bindHandlers()
    {   
        this.onCloseClick = this.onCloseClick.bind(this);
        // this.onPlayClicked = this.onPlayClicked.bind(this);
        // this.onStopClicked = this.onStopClicked.bind(this);
        // this.getLikeCount = this.getLikeCount.bind(this);
    }

    draw(props: ToneDetailsPopupComponentProps, state: UIComponentState, cssStyle: ToneDetailsPopupCSSStyle): JSX.Element | boolean
    {
        
        super.draw(props, state, cssStyle);

        console.log("Expire Date :",props.toneDto.getPrice());
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                   <div id="tonedetails-web">
                       {
                           this.getWebView(props, state,cssStyle)
                       }
                   </div>
                   <div id="tonedetails-mobile">
                       {
                           this.getMobileView(props, state, cssStyle)
                       }

                   </div>
            </div>
        );
    }


    getWebView(props: ToneDetailsPopupComponentProps, state: UIComponentState, cssStyle: ToneDetailsPopupCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                 
                   
                   
                </div>
                <div style={cssStyle.getToneImgDivCSSStyle()}>
                        {/* <PlayerComponent playIconName={"play_black.svg"} pauseIconName={"pause_black.svg"} playerCSSStyle={new ToneDetailsPlayerCSSStyleImpl(props.context)} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> */}
                        <ImageLoaderComponent defaultImageName={"default_image.jpg"} context={props.context} imageLoaderCSSStyle={new ToneDetailsPopupImageLoaderCSSStyleImpl(props.context)} imagePath={props.toneDto.getImgPath()} />
                        <div style={cssStyle.getToneDetailsDivCSSStyle()}>
                            <div style={cssStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</div>
                            <div style={cssStyle.getArtistNameCSSStyle()}>{props.toneDto.getArtistName()}</div>
                        </div>
                       
                    </div>
            </>
        );
    }

    getMobileView(props: ToneDetailsPopupComponentProps, state: UIComponentState, cssStyle: ToneDetailsPopupCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getMobileTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getMobileCloseIconCSSStyle()}/>
                    </div>
                 
                   
                   
                </div>
                <div style={cssStyle.getMobileToneImgDivCSSStyle()}>
                        {/* <PlayerComponent playIconName={"play_black.svg"} pauseIconName={"pause_black.svg"} playerCSSStyle={new ToneDetailsPlayerCSSStyleImpl(props.context)} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> */}
                        <ImageLoaderComponent defaultImageName={"default_image.jpg"} context={props.context} imageLoaderCSSStyle={new ToneDetailsPopupImageLoaderCSSStyleImpl(props.context)} imagePath={props.toneDto.getImgPath()} />
                        <div style={cssStyle.getMobileToneDetailsDivCSSStyle()}>
                            <div style={cssStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</div>
                            <div style={cssStyle.getArtistNameCSSStyle()}>{props.toneDto.getArtistName()}</div>
                        </div>
                    </div>   
                       
                       
                    
            </>

        );
    }
    // onPlayComplete(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayComplete();
    // }
   
    // onPlayStop(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayStop();
    // }


    // getLikeCount(toneDto: ToneDto): string
    // {
    //     // return toneDto.getLikeCount() === undefined ? "0" : toneDto.getLikeCount();
    //     let formattedCount = "0";

    //     if(toneDto.getLikeCount() !== undefined)
    //     {      
    //         if(+toneDto.getLikeCount() < 1000)
    //         {
    //             formattedCount = toneDto.getLikeCount();
    //         }
    //         else if(+toneDto.getLikeCount() >= 1000 && +toneDto.getLikeCount() < 1000000)
    //         {
    //             formattedCount = (+toneDto.getLikeCount()/1000) + "K";
    //         }
    //         else
    //         {
    //             formattedCount = (+toneDto.getLikeCount()/1000000) + "M";
    //         }

    //         return formattedCount.replace(".0", "");
    //     }
    //     else
    //     {
    //         return formattedCount;
    //     }
    // }
    // private onPlayClicked(): void
    // {
    //     this.initialStateOfTonePlaying = true;
    //     this.getContext().getPlayerManager()
    //                 .startPlay((this.getUIProps() as ToneCardComponentProps).toneDto.getToneUrl(), this);
    // }

    // private onStopClicked(): void
    // {
    //     this.initialStateOfTonePlaying = false;

    //     this.getContext().getPlayerManager().stopPlay();
    // }


    private onCloseClick()
    {
        (this.getUIComponentHandler() as ToneDetailsPopupComponentHandler).onCloseClick();
    }


}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tonedetailspopup/tonedetailspopupview.tsx